/**
 * Archive page scripts.
 *
 * @package Autotrader
 */

import DtkResources from './components/resource';

DtkResources.init();
